import axios from '@axios'

function put(endpoint, data, params) {
  return axios.post(endpoint, data, { params: { _method: 'PUT' } })
}

export default {
  get: axios.get,
  post: axios.post,
  put,
  delete: axios.delete,

}
